export default function Checkbox({ label, disabled, checked, onChange }) {
  return (
    <label className={disabled ? 'disabled' : ''}>
      <input type='checkbox' className='checkbox' checked={checked} onChange={onChange} disabled={disabled} />
      {label}
    </label>
  )
}
